module.exports = __webpack_public_path__ + "img/ajedrez.053d458a.jpg";